import { Icon } from "../../../components/common/Icon";

export default function SchemaVersionBadge({ version }) {
    return <span className={'badge badge-dark align-middle ml-1'} title={`Schema version ${version}`}>
        <Icon icon={'schema'} small /> {version}
    </span>
}